// Autogenerated file
export const defaultChatInitializeTypesEnum = {
    LogistOrCreator: "LogistOrCreator",
    AllBidParticipants: "AllBidParticipants",
    LogistOrCreatorAndResponsible: "LogistOrCreatorAndResponsible",
};
export const defaultChatInitializeTypes = [
    { label: "Логист или создатель", value: "LogistOrCreator" },
    { label: "Все участники заявки", value: "AllBidParticipants" },
    { label: "Логист или создатель и ответственный", value: "LogistOrCreatorAndResponsible" },
];
